import PropTypes from "prop-types";
import {useRouter} from "next/router";
import Image from "next/image";

const ArticleCard = ({title, link, text, date, isLast = false, image, readMore}) => {
  const {basePath, push, locale} = useRouter();
  return (
    <div className={`article-card ${isLast && "article-card_last"}`} onClick={() => push(`/blog/${link}`)}>
      <Image className='article-card__image' src={`${basePath}/images/${image}`} width={isLast ? 490 : 350} height={isLast ? 300 : 215} alt=""/>
      <div className='article-card__content'>
        <h2 className="article-card__title">{title}</h2>
        <p className="article-card__date">{date}</p>
        <div className="article-card__description-block">
          <p className="article-card__text">{text}</p>
          <a className="article-card__link" href={locale === "en" ? `/blog/${link}` : `/${locale}/blog/${link}`}>
            {readMore}
            <Image src={`${basePath}/images/arrow-right.svg`} width={24} height={24} alt=""/>
          </a>
        </div>
      </div>
    </div>
  );
};

ArticleCard.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  isLast: PropTypes.bool,
  image: PropTypes.string.isRequired,
  readMore: PropTypes.string.isRequired,
};

export default ArticleCard;
